module.exports = __webpack_public_path__ + "static/profile-0808c0f3e19665ec35de499260e69944.png";